var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "104px",
    viewBox: "0 0 147 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5455AAFF-60AE-4078-B4E4-C4DEAE39E2F3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 147,
    height: 104,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-726.000000, -1561.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-Info",
    transform: "translate(726.000000, 1561.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAFAFC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-5",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 130,
    height: 22
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(6.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D8D8D8",
    cx: 6.66666667,
    cy: 6.66666667,
    r: 6.66666667
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.333333, 3.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5,2.95399306 C3.88071187,2.95399306 5,4.11525449 5,5.54774306 C5,6.06503059 4.59581262,6.484375 4.09722222,6.484375 L4.09722222,6.484375 L0.902777778,6.484375 C0.404187379,6.484375 0,6.06503059 0,5.54774306 C0,4.11525449 1.11928813,2.95399306 2.5,2.95399306 Z M2.5,0 C3.22870904,0 3.81944444,0.612887977 3.81944444,1.36892361 C3.81944444,2.12495925 3.22870904,2.73784722 2.5,2.73784722 C1.77129096,2.73784722 1.18055556,2.12495925 1.18055556,1.36892361 C1.18055556,0.612887977 1.77129096,0 2.5,0 Z",
    id: "Combined-Shape"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInfo);
export default __webpack_public_path__ + "static/media/UserInfo.9f59258e924813faf7baf03b1e85da84.svg";
export { ForwardRef as ReactComponent };